import React from "react";

/**
 * Label + value (or custom children) block for conversation order details.
 */
const OrderDetailField = ({
  label,
  value,
  labelClassName = "mb-0",
  children,
}) => {
  return (
    <div>
      <p className={`fw-bold ${labelClassName}`}>{label}</p>
      {children ?? <p>{value}</p>}
    </div>
  );
};

export default OrderDetailField;
